import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService, User } from '../user/auth.service';
import { UnsplashImageService } from '../unsplash/unsplash.service';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { RegistryService } from '../registry/registry.service';
import { Registry } from '../registry/registry';
import 'rxjs/add/operator/take';

@Component({
  selector: 'app-guest-mode-popup',
  templateUrl: './guest-mode-popup.component.html',
  styleUrls: ['./guest-mode-popup.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class GuestModePopupComponent implements OnInit {

  hide: boolean;
  user: User;
  howItWorks = false;
  aboutHitchd = false;
  registry: Registry;
  @Input() showPopup: boolean = false;
  constructor(private _unsplashImageService: UnsplashImageService,
    private _registryService: RegistryService,
    private _authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private _registryFirebaseService: RegistryFirebaseService

  ) {


    // this.router.events.subscribe((event) => {

    //         if (((this.router.url.indexOf('/help/about-hitchd') > -1))) {
    //           this.showPopup = true;
    //           const body = document.getElementsByTagName('body')[0];
    //           body.style.overflow = "hidden";
    //           this.aboutHitchd = true;
    //           this.howItWorks = false;
    //         }
    //        else if (((this.router.url.indexOf('/help/how-it-works') > -1))) {
    //           this.showPopup = true;
    //           const body = document.getElementsByTagName('body')[0];
    //           body.style.overflow = "hidden";
    //           this.howItWorks = true;
    //           this.aboutHitchd = false;
    //         }
    //         else{
    //           this.showPopup =false;
    //         }
    //       });
        }


  handleKeyboardEvents(event: any) {
    if (this.showPopup && event.keyCode == 27) {

      this.close();
    }

  }



  ngOnInit() {

    this.user = this.route.snapshot.data.user;
    this.registry = this.route.snapshot.data.registry;

    // this._registryService.welcomeEmitted$.subscribe(() => {
    //   if (( (this.router.url.endsWith('/registry'))) || (this.router.url.indexOf('/registry/welcome') > -1)) {
    //     this.showPopup = true;

    //     const body = document.getElementsByTagName('body')[0];

    //     //
    //     body.style.overflow = "hidden";


    //   }

    // });

    this._registryService.showGenericPopup$.subscribe(popupType => {

      if (popupType == "guest/how-it-works"){
      this.showPopup = true;
      const body = document.getElementsByTagName('body')[0];    
      body.style.overflow = 'hidden';
      } else {
        this.close();
      }
  
    });


  }






  close() {

    if(!this.showPopup) {
      return;
    }
    
    this.showPopup = false;

    //this.router.navigate(["/"+this._registryFirebaseService.registry.registryName], );
    let body = document.getElementsByTagName('body')[0];
    body.style.overflow = "auto";
    //this._registryService.emitHeaderPopupClosed();

  }

}



// WEBPACK FOOTER //
// ./src/app/guest-mode-popup/guest-mode-popup.component.ts